import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { CustomTab } from '../../components';
import ProductDetailSale from '../../components/sale/ProductDetailSale';
import { getVersionService } from '../../services/sale/servipagosService';
import { Box, Grid } from '@mui/material';
import { setTitle } from 'redux/slices/uiSlice';

const SaleTabScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showDetail } = useSelector(store => store.airTimeSale);
  const { bags } = useSelector(store => store.session);
  const bagTAE = bags.find(bag => bag.type === 'TAE');
  const bagPDS = bags.find(bag => bag.type === 'PDS');
  useEffect(() => {
    dispatch(setTitle('Venta'));
    // getVersionService()
    // eslint-disable-next-line
  }, [])

  return (
    <Box mt={-2}>
      <CustomTab
        base='/venta'
        panels={[
          bagTAE && {
            name: "Tiempo Aire",
            route: '/venta/tiempo-aire',
            onChange: () => navigate('tiempo-aire'),
            content: <Outlet />
          },
          bagPDS && {
            name: "Pago de Servicios",
            route: '/venta/servicios',
            onChange: () => navigate('servicios'),
            content: <Outlet />
          },
          bagPDS && {
            name: "Tarjetas de Regalo",
            route: '/venta/tarjetas-regalo',
            onChange: () => navigate('tarjetas-regalo'),
            content: <Outlet />
          }
        ].filter(Boolean)}
      />
    </Box>
  )
}

export default SaleTabScreen;